module.exports = __webpack_public_path__ + "static/media/arrowDropDown.453e259e.svg";